(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vybe-v2-functional"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const source=root.querySelector('[data-benefits]');const inner=source.querySelector('.metafield-rich_text_field')||source;let card=null,body=null,count=0;const cards=[];
function readBenefits(node){if(node.nodeType===3){if(body)body.append(document.createTextNode(node.textContent));return;}if(node.nodeType!==1)return;if(node.tagName==='STRONG'||/^H[1-6]$/.test(node.tagName)){card=document.createElement('article');card.className='vf-benefit';card.dataset.number=String(++count).padStart(2,'0');const h=document.createElement('h3');h.textContent=node.textContent;body=document.createElement('p');card.append(h,body);cards.push(card);return;}if(node.tagName==='BR'){if(body)body.append(document.createTextNode(' '));return;}Array.from(node.childNodes).forEach(readBenefits);if(body&&node.tagName==='P')body.append(document.createTextNode(' '));}
Array.from(inner.childNodes).forEach(readBenefits);if(cards.length){source.replaceChildren(...cards);source.classList.add('is-grid');}
const tabs=Array.from(root.querySelectorAll('[role=tab]'));function activate(i){tabs.forEach((tab,j)=>{tab.setAttribute('aria-selected',String(i===j));tab.tabIndex=i===j?0:-1;root.querySelector('#'+tab.getAttribute('aria-controls')).hidden=i!==j;});}tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(i));tab.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();activate(n);tabs[n].focus();});});
const stage=root.querySelector('[data-can-stage]'),cans=Array.from(root.querySelectorAll('[data-can]')),section=root.querySelector('.vf-flavours');let current=0,start=null,lastSwipe=0;if(!cans.length)return;
function choose(index,sync){current=(index+cans.length)%cans.length;cans.forEach((can,i)=>{let offset=(i-current+cans.length)%cans.length;if(offset>cans.length/2)offset-=cans.length;can.dataset.position=offset;can.setAttribute('aria-pressed',String(i===current));can.tabIndex=Math.abs(offset)<=1?0:-1;});const selected=cans[current];root.querySelector('[data-flavour-title]').textContent=selected.dataset.name;root.querySelector('[data-flavour-description]').textContent=selected.dataset.description;root.querySelector('[data-counter]').textContent=(current+1)+' / '+cans.length;section.style.setProperty('--flavour-color',selected.dataset.color);if(sync){const button=Array.from(document.querySelectorAll('[data-vybe-product] [data-flavour-value]')).find(b=>b.dataset.flavourValue===selected.dataset.name);if(button&&!button.classList.contains('is-selected'))button.click();}}
cans.forEach((can,i)=>can.addEventListener('click',()=>{if(Date.now()-lastSwipe>400)choose(i,true);}));root.querySelector('[data-prev]').addEventListener('click',()=>choose(current-1,true));root.querySelector('[data-next]').addEventListener('click',()=>choose(current+1,true));stage.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();choose(current+(e.key==='ArrowRight'?1:-1),true);}});stage.addEventListener('pointerdown',e=>{start={x:e.clientX,y:e.clientY};});stage.addEventListener('pointerup',e=>{if(start){const dx=e.clientX-start.x,dy=e.clientY-start.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){lastSwipe=Date.now();choose(current+(dx<0?1:-1),true);}}start=null;});stage.addEventListener('pointercancel',()=>{start=null;});

const main=document.querySelector('[data-vybe-product]'),flavourSelect=root.querySelector('[data-local-flavour]'),localAdd=root.querySelector('[data-local-add]');
function syncPurchase(){if(!main)return;const selected=main.querySelector('.vybe-flavour.is-selected');if(selected)flavourSelect.value=selected.dataset.flavourValue;root.querySelectorAll('[data-local-pack]').forEach(button=>{const original=Array.from(main.querySelectorAll('[data-size-value]')).find(b=>b.dataset.sizeValue===button.dataset.localPack);if(original){button.setAttribute('aria-pressed',String(original.classList.contains('is-selected')));button.querySelector('[data-local-pack-price]').textContent=original.querySelector('[data-size-price]')?.textContent||'';}});const original=main.querySelector('#btn-add');if(original){localAdd.disabled=original.disabled;root.querySelector('[data-local-add-label]').textContent=main.querySelector('[data-add-label]')?.textContent||(original.disabled?'SOLD OUT':'ADD TO CART');root.querySelector('[data-local-price]').textContent=main.querySelector('[data-add-price]')?.textContent||'';}const error=main.querySelector('[data-purchase-error]'),localError=root.querySelector('[data-local-error]');localError.hidden=!error||error.hidden;localError.textContent=error&&!error.hidden?error.textContent:'';}
flavourSelect.addEventListener('change',()=>{const i=cans.findIndex(c=>c.dataset.name===flavourSelect.value);if(i>=0)choose(i,true);syncPurchase();});root.querySelectorAll('[data-local-pack]').forEach(button=>button.addEventListener('click',()=>{const original=Array.from(main.querySelectorAll('[data-size-value]')).find(b=>b.dataset.sizeValue===button.dataset.localPack);if(original)original.click();syncPurchase();}));localAdd.addEventListener('click',()=>{if(localAdd.disabled)return;const original=main.querySelector('[data-sticky-add]')||main.querySelector('#btn-add');if(original)original.click();syncPurchase();});if(main){new MutationObserver(syncPurchase).observe(main,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','hidden','class']});}syncPurchase();
function sync(name){const i=cans.findIndex(c=>c.dataset.name===name);if(i>=0)choose(i,false);}document.addEventListener('vybe:flavour-change',e=>{if(root.isConnected)sync(e.detail.flavour);});choose(0,false);sync(document.querySelector('[data-vybe-product] .vybe-flavour.is-selected')?.dataset.flavourValue);
}document.querySelectorAll('[data-vybe-story]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-vybe-story]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
